/**
 * @generated SignedSource<<8adfd4c6293aff7bd06e2a6f139343c8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TermsAndConditionsConsentMutation$variables = {};
export type TermsAndConditionsConsentMutation$data = {
  readonly updateConsentSettings: {
    readonly " $fragmentSpreads": FragmentRefs<"TermsAndConditionsConsent_consentSettings">;
  } | null;
};
export type TermsAndConditionsConsentMutation = {
  response: TermsAndConditionsConsentMutation$data;
  variables: TermsAndConditionsConsentMutation$variables;
};

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TermsAndConditionsConsentMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ConsentSettingsConnection",
        "kind": "LinkedField",
        "name": "updateConsentSettings",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TermsAndConditionsConsent_consentSettings"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "TermsAndConditionsConsentMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ConsentSettingsConnection",
        "kind": "LinkedField",
        "name": "updateConsentSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentVersion",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "consentedVersion",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "487ebc5bcc8725c419e265282fb1f313",
    "id": null,
    "metadata": {},
    "name": "TermsAndConditionsConsentMutation",
    "operationKind": "mutation",
    "text": "mutation TermsAndConditionsConsentMutation {\n  updateConsentSettings {\n    ...TermsAndConditionsConsent_consentSettings\n  }\n}\n\nfragment TermsAndConditionsConsent_consentSettings on ConsentSettingsConnection {\n  currentVersion\n  consentedVersion\n}\n"
  }
};

(node as any).hash = "8bcc04bef48bd9c8ab27eefb0088b3e0";

export default node;
